<template>
<div class="form-group" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        hor: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.hor) {
                _class.push('row')
            }

            return _class
        }
    }
}
</script>